import React from "react";
import successimage from "../../assets/Images/modalerrorimage.svg";
import { Box, Modal } from "@mui/material";
import styles from "./PoliticalModal.module.scss";

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

interface props {
  openModal: boolean;
  handleDone: any;
}

const PloiticalModal = ({ openModal, handleDone }: props) => {
  return (
    <Modal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={openModal}
      slotProps={{
        backdrop: {
          timeout: 100,
        },
      }}
      BackdropProps={{
        style: {
          background: "rgba(31, 41, 55, 0.30)",
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
        },
        timeout: 100,
      }}
    >
      <Box sx={successModalStyles}>
        <div className={styles.modalWrapper}>
          <img src={successimage} alt="" className={styles.icon} />
          <p className={styles.title}>
            {"PEP/rPEP Account Opening Restriction"}
          </p>
          <p className={styles.desc}>
            Account opening is currently not available for Politically Exposed
            Persons or their associates. For more information, please contact
            support at <span style={{ color: "#3263E5" }}>080 4670 2020.</span>
          </p>
          <div className={styles.cancelButtonsSection}>
            <div className={styles.submit} onClick={handleDone}>
              Close
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default PloiticalModal;
